import { Injectable } from '@angular/core';
import { ScrollService } from '@df/util/service/scroll.service';
import { UseService } from '@df/util/service/use.service';

const useId = 'blockScrollService';

/**
 * @deprecated Please use scroll service directly
 */
@Injectable({
    providedIn: 'root'
})
export class BlockScrollService {
    constructor(
        private useService: UseService,
        scrollService: ScrollService
    ) {
        let unlock: (() => void) | undefined;
        useService.subscribe(useId, locked => {
            if (locked !== !!unlock) {
                if (locked) {
                    unlock = scrollService.blockScroll();
                } else if (unlock) {
                    unlock();
                    unlock = undefined;
                }
            }
        });
    }

    enable(blockingObject: any): void {
        this.useService.lock(useId, blockingObject);
    }

    disable(blockingObject: any): void {
        this.useService.unlock(useId, blockingObject);
    }
}
